export default __webpack_public_path__ + "static/media/manageexpert.2c0ddf39.svg";